import React, { useState, useEffect, useContext, useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import './Import.css';
//import Loader from 'ui-component/Loader';
import CircleProgress  from '../../../components/CircleProgress/CircleProgress';
import NotificationManager from 'react-notifications/lib/NotificationManager';
import axios from 'axios';
import { AuthContext } from '../../../contexts/authContext';
import { AppAuthGlobalVariables } from '../../../contexts/AppAuthContext';
import * as utils from '../../../utils/CommonUtilities';
import PropTypes from 'prop-types';
import {
    Paper,
    Box,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Tabs,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Divider,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Tooltip
} from '@mui/material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import Draggable from 'react-draggable';
import { useDropzone } from 'react-dropzone';
import config from '../../../config';

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`
    };
}

function PaperComponent(props) {
    return (
        <Draggable handle="#draggable-dialog-campaign-dett" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
}

const automaticFileTypes = ['Adbook', 'Portfolio', 'Workday', 'Clients/Agencies'];

function Import(props) {
    const auth = useContext(AuthContext);
    const navigate = useNavigate();
    const {privs} = useContext(AppAuthGlobalVariables);
    const msgErrorGeneric = "An unexpected error has occurred";
    const msgErrorPrivileges = "Insufficient privileges to perform the operation";
    const msgSuccess = "Operation successfully completed";
    const [loading, setLoading] = useState(false);
    const [tabValue, setTabValue] = useState(undefined);
    const [automaticFileType, setAutomaticFileType] = useState('');
    const [programmaticFileType, setProgrammaticFileType] = useState('');
    const [automaticFiles, setAutomaticFiles] = useState([]);
    const [programmaticFiles, setProgrammaticFiles] = useState([]);
    const [logRows, setLogRows] = useState([]);
    const [modalConfirmProgrammatic, setModalConfirmProgrammatic] = useState(false);
    const [checkUpdateAuto, setCheckUpdateAuto] = useState(true);
    const [checkUpdateProg, setCheckUpdateProg] = useState(false);
    const [lastAutoUpload, setLastAutoUpload] = useState('');
    //const [lastProgUpload, setLastProgUpload] = useState('');
    const [modalCheck, setModalCheck] = useState(false);
    const [checkRows, setCheckRows] = useState([]);
    const [openConfirmAutomatic, setOpenConfirmAutomatic] = useState(false);
    const [acceptedAutomaticFiles, setAcceptedAutomaticFiles] = useState([]);
    const [acceptedProgrammaticFiles, setAcceptedProgrammaticFiles] = useState([]);
    const [countElapsedTime, setCountElapsedTime] = useState(0);
    const [openWaitAutomatic, setOpenWaitAutomatic] = useState(false);

    useEffect(() => {
        //Begin privileges check
        //READ
        if(
            privs.P_ADBOOK              < 'R' &&
            privs.P_WORKDAY             < 'R' &&
            privs.P_SF_PORTFOLIO        < 'R' &&
            privs.P_ANAGRAFICHE_CLI_AGE < 'R' &&
            privs.P_PROGRAMMATIC_PG     < 'R' &&
            privs.P_PROGRAMMATIC_PP     < 'R' &&
            privs.P_MANUAL_ADJUSTMENTS  < 'R' 
        ){
            navigate('/pages/error', { replace: true });
        }

        let calcTabVal = 0;
        if(
            privs.P_ADBOOK              >= 'R' ||
            privs.P_WORKDAY             >= 'R' ||
            privs.P_SF_PORTFOLIO        >= 'R' ||
            privs.P_ANAGRAFICHE_CLI_AGE >= 'R'
        ){
            setTabValue(0);
        }else{
            calcTabVal=1;
            setTabValue(1);
        }

        const fileType = calcTabVal === 0 ? 'A' : 'M';
        getLogLoadFiles(fileType);
    }, []);

    const getLogLoadFiles = async (uploadType) => {
        try {
            setLoading(true);

            const params = {
                uploadType
            };

            const axiosParams = {
                url: '/exchange/get-log-load-files',
                method: 'get',
                baseURL: config.API_URL,
                headers: { Authorization: `Bearer ${await auth.getAccessTokenForBE()}` },
                params
            };

            const response = await axios(axiosParams);
            const data = response.data;
            setLogRows(data);

            if (uploadType === 'A') {
                if (data.length > 0) {
                    setLastAutoUpload(data[0].DATA_ULTIMA_ELABORAZIONE);
                } else {
                    setLastAutoUpload('');
                }
            }

            setLoading(false);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                NotificationManager.error(msgErrorGeneric, '', 10000);
            }
            setLoading(false);
        }
    };

    const onDrop = useCallback(async (acceptedFiles) => {
        if (acceptedFiles && acceptedFiles.length > 0) {
            setAutomaticFiles([]);
            setProgrammaticFiles([]);

            if (tabValue === 0 && automaticFileType !== '') {
                setAcceptedAutomaticFiles(acceptedFiles);
                setOpenConfirmAutomatic(true);
            } else if (tabValue === 1 && programmaticFileType !== '') {
                setAcceptedProgrammaticFiles(acceptedFiles);
                setModalConfirmProgrammatic(true);
            }
        }
    });

    const {
        /* acceptedFiles, */
        getRootProps,
        getInputProps,
        open,
        isFocused,
        isDragAccept,
        isDragReject
    } = useDropzone({
        onDrop,
        accept: { 'text/csv': ['.csv'] },
        multiple: false,
        maxSize: 50 * 1024 * 1024
    });

    const baseStyle = {
        width: '300px',
        height: '95px',
        marginTop: '30px',
        flexDirection: 'column',
        alignItems: 'center',
        borderWidth: 3,
        borderRadius: 5,
        borderColor: '#aaaaaa',
        borderStyle: 'dashed',
        backgroundColor: '#fafafa',
        color: '#666666',
        outline: 'none',
        transition: 'border .24s ease-in-out'
    };

    const focusedStyle = {
        borderColor: '#aaaaaa'
    };

    const acceptStyle = {
        borderColor: '#25b256'
    };

    const rejectStyle = {
        borderColor: '#00e676'
    };

    const dropZonestyle = useMemo(
        () => ({
            ...baseStyle,
            ...(isFocused ? focusedStyle : {}),
            ...(isDragAccept ? acceptStyle : {}),
            ...(isDragReject ? rejectStyle : {})
        }),
        [isFocused, isDragAccept, isDragReject]
    );

    const dropAutomaticFile = async () => {
        const idElapsedTimeInterval = setInterval(() => {
            setCountElapsedTime((prev) => prev + 1);
        }, 1000);

        try{
            setOpenConfirmAutomatic(false);
            setOpenWaitAutomatic(true);

            setCheckUpdateAuto(false);
            setLoading(true);
            const fileName = acceptedAutomaticFiles[0].name;
            const fileType = automaticFileType;
            setAutomaticFiles([...acceptedAutomaticFiles]);
            const form = new FormData();

            form.append('file', acceptedAutomaticFiles[0]);

            const axiosParams = {
                url: `/exchange/upload-auto-file?fileName=${fileName}&fileType=${fileType}`,
                method: 'post',
                baseURL: config.API_URL,
                headers: { 
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${await auth.getAccessTokenForBE()}` 
                },
                data: form
            };

            const response = await axios(axiosParams);

            const retVal = response.data.nRetVal;

            if (retVal <= 0) {
                let errorMessage = '';
                switch (retVal) {
                    case 0:
                        errorMessage = msgErrorGeneric;
                        break;
                    case -1:
                        errorMessage = 'The removal of one of the old files from the directory failed';
                        break;
                    case -2:
                        errorMessage = 'The download of the files from the bucket failed';
                        break;
                    case -3:
                        errorMessage = 'The file was not downloaded to the directory';
                        break;
                    case -4:
                        errorMessage = 'The Adbook file contains multiple years';
                        break;
                    case -5:
                        errorMessage = 'Some data in the file is incorrect';
                        break;                        
                    case -6:
                        errorMessage = 'The file is empty or has an incorrect format';
                        break;
                    case -7:
                        errorMessage = 'Failed to update Commissions';
                        break;
                    case -8:
                        errorMessage = 'The file is not compliant or contains data that are discarded';
                        break;
                    case -24:
                        errorMessage = msgErrorPrivileges;
                        break;
                    default:
                        errorMessage = msgErrorGeneric;
                        break;
                }
                NotificationManager.error(errorMessage, '', 10000);
                setLoading(false);
                clearInterval(idElapsedTimeInterval);
                setOpenWaitAutomatic(false);
                setAutomaticFiles([]);
                setCountElapsedTime(0);
                return;
            }

            NotificationManager.success(msgSuccess, '', 10000);

            setCheckUpdateAuto(true);
            getLogLoadFiles('A');
            setLoading(false);
            clearInterval(idElapsedTimeInterval);
            setCountElapsedTime(0);
            setOpenWaitAutomatic(false);
        }catch(e){
            setLoading(false);
            clearInterval(idElapsedTimeInterval);
            setOpenWaitAutomatic(false);
            setAutomaticFiles([]);
            setCountElapsedTime(0);
            NotificationManager.error(msgErrorGeneric, '', 10000);
        }
    };

    const dropProgrammaticFile = async () => {
        try{
            setCheckUpdateProg(false);
            setLoading(true);
            
            setProgrammaticFiles([...acceptedProgrammaticFiles]);
            const form = new FormData();
            form.append('file', acceptedProgrammaticFiles[0]);
            const fileName = acceptedProgrammaticFiles[0].name;
            const fileType = programmaticFileType;

            const axiosParams = {
                url: `/exchange/upload-prog-file?fileName=${fileName}&fileType=${fileType}`,
                method: 'post',
                baseURL: config.API_URL,
                headers: { 
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${await auth.getAccessTokenForBE()}` 
                },
                data: form
            };

            const response = await axios(axiosParams);

            if (response.data.nRetVal === 1) {
                checkFileProvvImport();
                setModalConfirmProgrammatic(false);
            } else {
                NotificationManager.error(msgErrorGeneric, '', 10000);
            }

            setLoading(false);
        }catch(e){
            setLoading(false);
            NotificationManager.error(msgErrorGeneric, '', 10000);
        }
    };

    const handleChangeTab = (event, newValue) => {
        setTabValue(newValue);
        const fileType = newValue === 0 ? 'A' : 'M';
        getLogLoadFiles(fileType);
    };

    const handleChangeAutoFileType = (event) => {
        setAutomaticFileType(event.target.value);
        setAutomaticFiles([]);
    };

    const handleChangeProgFileType = (event) => {
        setProgrammaticFileType(event.target.value);
        setProgrammaticFiles([]);
    };

    const updateProgrammaticCommissions = async () => {
        setLoading(true);

        try {
            const fileName = acceptedProgrammaticFiles[0].name;

            const params = {
                fileName,
                type: programmaticFileType
            };

            const axiosParams = {
                url: '/exchange/aggiorna-provvigioni',
                method: 'post',
                baseURL: config.API_URL,
                headers: { Authorization: `Bearer ${await auth.getAccessTokenForBE()}` },
                params
            };

            const axiosResponse = await axios(axiosParams);
            let response = axiosResponse.data;
            const retVal = response.nRetVal;

            if (retVal <= 0) {
                let errorMessage = '';
                switch (retVal) {
                    case 0:
                        errorMessage = msgErrorGeneric;
                        break;
                    case -2:
                        errorMessage = 'Update of the Commissions table failed';
                        break;
                    case -24:
                        errorMessage = msgErrorPrivileges;
                        break;
                    default:
                        errorMessage = msgErrorGeneric;
                        break;
                }
                NotificationManager.error(errorMessage, '', 10000);
                setLoading(false);
                setProgrammaticFiles([]);
                return;
            }

            NotificationManager.success(msgSuccess, '', 10000);
            setLoading(false);

            setCheckUpdateProg(true);
            getLogLoadFiles('M');

        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                NotificationManager.error(msgErrorGeneric, '', 10000);
            }
            setProgrammaticFiles([]);
            setLoading(false);
        }
    };

    const checkFileProvvImport = async () => {
        try {
            setLoading(true);

            const fileName = acceptedProgrammaticFiles[0].name;

            const params = {
                fileName,
                type: programmaticFileType
            };

            const axiosParams = {
                url: '/exchange/check-file-provv-import',
                method: 'get',
                baseURL: config.API_URL,
                headers: { Authorization: `Bearer ${await auth.getAccessTokenForBE()}` },
                params
            };

            const response = await axios(axiosParams);
            const data = response.data;
            if (data.length > 0) {
                if (parseInt(data[0].RETVAL) === 1) {
                    updateProgrammaticCommissions();
                } else {
                    setCheckRows(data);
                    setModalCheck(true);
                    setLoading(false);
                }
            }
            
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                NotificationManager.error(msgErrorGeneric, '', 10000);
            }
            setLoading(false);
        }
    };

    const handleCloseModalCheck = () => {
        getLogLoadFiles('M');
        setProgrammaticFiles([]);
        setModalCheck(false);
    };

    const handleModalCheck = async () => {
        updateProgrammaticCommissions();
        setModalCheck(false);
    };

    const wrapBySectionSign = (html) => {
        if (html) {
            const arrHtml = html.split('§');
            return (
                <>
                    {arrHtml.map((item, index) => (
                        <div key={index}>{item}</div>
                    ))}
                </>
            );
        } else {
            return '';
        }
    };

    return (
        <div className='component-container home'>
			<div className='component-card'>
                <div className="import-file">
                    { loading && <CircleProgress /> }
                    <Dialog
                        open={openConfirmAutomatic}
                        onClose={() => setOpenConfirmAutomatic(false)}
                        PaperComponent={PaperComponent}
                        sx={{
                            '& .MuiDialog-container': {
                                '& .MuiPaper-root': {
                                    width: '50%',
                                    maxWidth: '600px'
                                }
                            }
                        }}
                    >
                        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-campaign-dett">
                            Upload and Update Automatic File
                        </DialogTitle>
                        <DialogContent>
                            <p>
                                File Type: <strong>{automaticFileTypes[automaticFileType]}</strong>
                            </p>
                            <p>
                                Loading File: <strong>{acceptedAutomaticFiles.length > 0 ? acceptedAutomaticFiles[0]?.name : ''}</strong>
                            </p>
                            <p>
                                By confirming the operation, the file will be uploaded and the data structures and cubes (Roobeek) will be updated.
                            </p>
                            <p>The operation may take a few minutes.</p>
                            <p>
                                <strong>Do you confirm that you wish to proceed?</strong>
                            </p>
                        </DialogContent>
                        <DialogActions>
                            <Button variant="outlined" onClick={() => setOpenConfirmAutomatic(false)}>
                                Cancel
                            </Button>
                            <Button variant="contained" style={{ backgroundColor: '#2789d8', color: 'white' }} onClick={dropAutomaticFile}>
                                Confirm
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        open={openWaitAutomatic}
                        onClose={() => setOpenWaitAutomatic(false)}
                        PaperComponent={PaperComponent}
                        sx={{
                            '& .MuiDialog-container': {
                                '& .MuiPaper-root': {
                                    width: '50%',
                                    maxWidth: '600px'
                                }
                            }
                        }}
                    >
                        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-campaign-dett">
                            Upload and Update Automatic File
                        </DialogTitle>
                        <DialogContent>
                            <p>Upload and Update in progress.</p>
                            <p>The operation may take a few minutes. Do not change the page and do not close the browser.</p>
                            <p>
                                Elapsed time: {countElapsedTime} second{countElapsedTime === 1 ? '' : 's'}.
                            </p>
                        </DialogContent>
                    </Dialog>

                    <Dialog
                        open={modalConfirmProgrammatic}
                        onClose={() => setModalConfirmProgrammatic(false)}
                        PaperComponent={PaperComponent}
                        sx={{
                            '& .MuiDialog-container': {
                                '& .MuiPaper-root': {
                                    width: '80%',
                                    maxWidth: '800px'
                                }
                            }
                        }}
                    >
                        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-campaign-dett">
                            Upload and Update Programmatic File
                        </DialogTitle>
                        <DialogContent>
                            {tabValue === 1 && acceptedProgrammaticFiles.length > 0 && (
                                <>The Sales Commissions will be recalculated based on the last file uploaded ({acceptedProgrammaticFiles[0].name}).</>
                            )}
                            <br />
                            <br />
                            Do you want to continue?
                        </DialogContent>
                        <DialogActions>
                            <Button variant="outlined" onClick={() => setModalConfirmProgrammatic(false)}>
                                Cancel
                            </Button>
                            <Button variant="contained" style={{ backgroundColor: '#2789d8', color: 'white' }} onClick={dropProgrammaticFile}>
                                Update Commissions
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        open={modalCheck}
                        onClose={handleCloseModalCheck}
                        PaperComponent={PaperComponent}
                        sx={{
                            '& .MuiDialog-container': {
                                '& .MuiPaper-root': {
                                    width: '100%',
                                    maxWidth: '1200px'
                                }
                            },
                            width: '100%'
                        }}
                    >
                        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-campaign-dett">
                            Check Update Commissions
                        </DialogTitle>
                        <DialogContent>
                            <Table className="tab-check" aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="left">Message</TableCell>
                                        <TableCell align="left">Client</TableCell>
                                        <TableCell align="left">Agency</TableCell>
                                        <TableCell align="center" style={{ minWidth: '150px' }}>
                                            Revenue
                                        </TableCell>
                                        <TableCell align="center">Comp. Date</TableCell>
                                        <TableCell align="left">Brand</TableCell>
                                        <TableCell align="left">Platform</TableCell>
                                        <TableCell align="left">Impressions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {checkRows.map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell align="left">{row.ERROR_MESSAGE_DESC}</TableCell>
                                            <TableCell align="left">
                                                {row.CLIENT_CODE !== null ? `(${row.CLIENT_CODE}) ${row.CLIENT_DESC}` : ''}
                                            </TableCell>
                                            <TableCell align="left">
                                                {row.AGENCY_CODE !== null ? `(${row.AGENCY_CODE}) ${row.AGENCY_CODE}` : ''}
                                            </TableCell>
                                            <TableCell align="center" style={{ minWidth: '150px' }}>
                                                {utils.formatFloatNum(row.REVENUE, 0, 2, '€')}
                                            </TableCell>
                                            <TableCell align="center">{utils.formatDateFromDB(row.COMP_DATE)}</TableCell>
                                            <TableCell align="left">{row.BRAND_DESC}</TableCell>
                                            <TableCell align="left">{row.PLATFORM_DESC}</TableCell>
                                            <TableCell align="left">{row.IMPRESSIONS}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </DialogContent>
                        <DialogActions>
                            <Button variant="outlined" onClick={handleCloseModalCheck}>
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                onClick={handleModalCheck}
                                disabled={checkRows.find((item) => item.FLAG_BLOCKING === 'Y') !== undefined}
                            >
                                Update Commissions
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Paper style={{ width: '110%' }}>
                        {/* <div className="title-section">
                            <Typography variant="h6" sx={{ fontWeight: 500 }}>
                                Import & Update
                            </Typography>
                        </div> */}
                        <div className="card import">
            
                            <Tabs value={tabValue} onChange={handleChangeTab} aria-label="basic tabs example">
                                {(
                                 privs.P_ADBOOK              >= 'R' ||
                                 privs.P_WORKDAY             >= 'R' ||
                                 privs.P_SF_PORTFOLIO        >= 'R' ||
                                 privs.P_ANAGRAFICHE_CLI_AGE >= 'R')&&(<Tab label="Automatic File" {...a11yProps(0)} />)}
                                {(
                                    privs.P_PROGRAMMATIC_PG     >= 'R' ||
                                    privs.P_PROGRAMMATIC_PP     >= 'R' ||
                                    privs.P_MANUAL_ADJUSTMENTS  >= 'R')&&(<Tab label="Manual File" {...a11yProps(1)} />)}
                            </Tabs>
                            <CustomTabPanel value={tabValue} index={0} className="tab-panel">
                                {false && (
                                    <div className="cmd-update">
                                        <Button variant="contained" onClick={() => setModalConfirmProgrammatic(true)} disabled={!checkUpdateAuto}>
                                            Update Commissions
                                        </Button>
                                    </div>
                                )}
                                <Box>
                                    <Typography variant="h7" className="summary">
                                        Please&nbsp;<strong>choose the type of file</strong>&nbsp;you are uploading and then&nbsp;
                                        <strong>upload a single file</strong>.
                                    </Typography>

                                    <div className="flex-upload">
                                        <FormControl variant="standard" sx={{ minWidth: 200 }}>
                                            <InputLabel id="file-automatic-type-label">File type</InputLabel>
                                            <Select
                                                labelId="file-automatic-type-label"
                                                id="automatic-file-type"
                                                value={automaticFileType}
                                                label="File Type"
                                                onChange={handleChangeAutoFileType}
                                            >
                                                <MenuItem key={-1} value={''}>
                                                    &nbsp;
                                                </MenuItem>
                                                {privs.P_ADBOOK >= 'W' && (
                                                    <MenuItem key={0} value={0}>
                                                        Adbook
                                                    </MenuItem>
                                                )}
                                                {privs.P_SF_PORTFOLIO >= 'W' && (
                                                    <MenuItem key={1} value={1}>
                                                        Portfolio
                                                    </MenuItem>
                                                )}
                                                {privs.P_WORKDAY >= 'W' && (
                                                    <MenuItem key={2} value={2}>
                                                        Workday
                                                    </MenuItem>
                                                )}
                                                {privs.P_ANAGRAFICHE_CLI_AGE >= 'W' && (
                                                    <MenuItem key={3} value={3}>
                                                        Clients/Agencies
                                                    </MenuItem>
                                                )}
                                            </Select>
                                        </FormControl>

                                        <div
                                            className={automaticFiles.length === 1 && checkUpdateAuto ? 'drop-box loaded' : 'drop-box'}
                                            {...getRootProps({ style: dropZonestyle })}
                                        >
                                            <input {...getInputProps()} />

                                            {automaticFiles.length === 0 && (
                                                <>
                                                    <p style={{ textAlign: 'center' }}>Click to load a file</p>
                                                    <p style={{ textAlign: 'center' }}>...or Drag it here.</p>
                                                </>
                                            )}

                                            {automaticFiles.length === 1 && !checkUpdateAuto && (
                                                <>
                                                    <p style={{ textAlign: 'center' }}>Upload and Update in progress...</p>
                                                </>
                                            )}

                                            {automaticFiles.length === 1 && checkUpdateAuto && (
                                                <>
                                                    <p className="drop-box-row" style={{ marginTop: '35px' }}>
                                                        Uploaded File: {automaticFiles[0].name}
                                                    </p>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </Box>

                                <Divider sx={{ margin: '20px 0' }} />

                                <TableContainer sx={{ width: '100%', marginTop: '20px' }}>
                                    <Typography variant="h5">Latest Automatic File Upload and Commissions Update performed:</Typography>

                                    <Table className="tab-log" aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="left">File Name</TableCell>
                                                <TableCell align="left">File Type</TableCell>
                                                <TableCell align="left">Upload Date</TableCell>
                                                <TableCell align="left">Upload User</TableCell>
                                                <TableCell align="left">Processed rows</TableCell>
                                                <TableCell align="left">Notes</TableCell>
                                                <TableCell align="left">Elapsed Time</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {logRows.map((row, index) => (
                                                <TableRow key={index}>
                                                    <TableCell align="left">{wrapBySectionSign(row.FILENAME)}</TableCell>
                                                    <TableCell align="left">{row.FILETYPE}</TableCell>
                                                    <TableCell align="left">
                                                        {utils.formatDateTimeFromDB(row.DATA_UPLOAD, {
                                                            day: 'numeric',
                                                            month: 'numeric',
                                                            year: 'numeric',
                                                            weekday: 'short'
                                                        })}
                                                    </TableCell>
                                                    <TableCell align="left">{row.USER_UPLOAD}</TableCell>
                                                    <TableCell align="left">{wrapBySectionSign(row.PROC_ROW_COUNTS)}</TableCell>
                                                    <TableCell align="left">{wrapBySectionSign(row.NOTES)}</TableCell>
                                                    <TableCell align="left">{row.ELAPSED_TIME}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </CustomTabPanel>
                            <CustomTabPanel value={tabValue} index={1} className="tab-panel">
                                {false && (
                                <div className="cmd-update">
                                    <Button
                                        variant="contained"
                                        onClick={() => setModalConfirmProgrammatic(true)}
                                        disabled={programmaticFiles.length === 0 || !checkUpdateProg}
                                    >
                                        Update Commissions
                                    </Button>
                                </div>
                                )}
                                <Box>
                                    <Typography variant="h7" className="summary">
                                        Please&nbsp;<strong>choose the type of file</strong>&nbsp;you are uploading and then&nbsp;
                                        <strong>upload a single file</strong>.
                                    </Typography>
                                    <Typography variant="h7" className="summary">
                                        (to apply the changes you will need to launch the&nbsp;<strong>Update Commissions</strong>&nbsp;command for
                                        each file you upload).
                                    </Typography>
                                    <div className="flex-upload">
                                        <FormControl variant="standard" sx={{ minWidth: 200 }}>
                                            <InputLabel id="file-programmatic-type-label" style={{ fontSize: 15 }}>
                                                File type
                                            </InputLabel>
                                            <Select
                                                labelId="file-programmatic-type-label"
                                                id="programmatic-file-type"
                                                value={programmaticFileType}
                                                onChange={handleChangeProgFileType}
                                                label="File Type"
                                            >
                                                <MenuItem key={-1} value={''}>
                                                    &nbsp;
                                                </MenuItem>
                                                {privs.P_PROGRAMMATIC_PG >= 'W' && (
                                                    <MenuItem key={0} value={'PG'}>
                                                        Programmatic Guaranteed
                                                    </MenuItem>
                                                )}
                                                {privs.P_PROGRAMMATIC_PP >= 'W' && (
                                                    <MenuItem key={1} value={'PP'}>
                                                        Programmatic Private
                                                    </MenuItem>
                                                )}
                                                {privs.P_MANUAL_ADJUSTMENTS >= 'W' && (
                                                    <MenuItem key={2} value={'MR'}>
                                                        Manual Adjustments
                                                    </MenuItem>
                                                )}
                                            </Select>
                                        </FormControl>

                                        <div
                                            className={programmaticFiles.length === 1 && checkUpdateProg ? 'drop-box loaded' : 'drop-box'}
                                            {...getRootProps({ style: dropZonestyle })}
                                        >
                                            <input {...getInputProps()} />

                                            {programmaticFiles.length === 0 && (
                                                <>
                                                    <p style={{ textAlign: 'center' }}>Click to load a file</p>
                                                    <p style={{ textAlign: 'center' }}>...or Drag it here.</p>
                                                </>
                                            )}

                                            {programmaticFiles.length === 1 && !checkUpdateProg && (
                                                <>
                                                    <p style={{ textAlign: 'center' }}>Upload and Update in progress...</p>
                                                </>
                                            )}

                                            {programmaticFiles.length === 1 && checkUpdateProg && (
                                                <>
                                                    <p className="drop-box-row">Uploaded File:</p>
                                                    <p className="drop-box-row" style={{ fontWeight: 'bold' }}>
                                                        {programmaticFiles.map((file, index) => (
                                                            <div key={index}>{file.name} </div>
                                                        ))}
                                                    </p>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </Box>

                                <Divider sx={{ margin: '20px 0' }} />

                                <TableContainer sx={{ width: '100%', marginTop: '20px' }}>
                                    <Typography variant="h5">Latest Manual File Upload and Commissions Update performed:</Typography>

                                    <Table className="tab-log" aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="left">File Name</TableCell>
                                                <TableCell align="left">File Type</TableCell>
                                                <TableCell align="left">Upload Date</TableCell>
                                                <TableCell align="left">Upload User</TableCell>
                                                <TableCell align="left">Processed rows</TableCell>
                                                <TableCell align="left">Notes</TableCell>
                                                <TableCell align="left">Elapsed Time</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {logRows.map((row, index) => (
                                                <TableRow key={index}>
                                                    <TableCell align="left">{row.FILENAME}</TableCell>
                                                    <TableCell align="left">{row.FILETYPE}</TableCell>
                                                    <TableCell align="left">
                                                        {utils.formatDateTimeFromDB(row.DATA_UPLOAD, {
                                                            day: 'numeric',
                                                            month: 'numeric',
                                                            year: 'numeric',
                                                            weekday: 'long'
                                                        })}
                                                    </TableCell>
                                                    <TableCell align="left">{row.USER_UPLOAD}</TableCell>
                                                    <TableCell align="left">{wrapBySectionSign(row.PROC_ROW_COUNTS)}</TableCell>
                                                    <TableCell align="left">{wrapBySectionSign(row.NOTES)}</TableCell>
                                                    <TableCell align="left">{row.ELAPSED_TIME}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </CustomTabPanel>
                        </div>
                    </Paper>
                </div>
            </div>
        </div>
    );
}

export default Import;
